module.exports = __webpack_public_path__ + "img/q&a15.9369ffa7.png";